import { useMutation, useQueryClient } from '@tanstack/vue-query';
import httpClient from '../httpClient';
import type { CreateSessionDto, ScribeSession } from '@/types';

export const useSessionCreateMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (dto: CreateSessionDto): Promise<ScribeSession> => {
      const response = await httpClient.post<ScribeSession>(
        '/v1/sessions',
        dto,
      );
      return response.data;
    },
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: ['scribeSessions'] });
    },
  });
};
